import { useState } from "react";
import { useNavigate, Link } from "react-router-dom";
import { Eye, EyeOff } from "lucide-react";
import { toast } from "sonner";
import { useAuth } from "@/context/AuthContext";

export default function Entrar() {
  const navigate = useNavigate();
  const { login } = useAuth();
  const [identifier, setIdentifier] = useState("");
  const [password, setPassword] = useState("");
  const [remember, setRemember] = useState(false);
  const [showPw, setShowPw] = useState(false);
  const [error, setError] = useState("");
  const [loading, setLoading] = useState(false);

  const submit = async (e) => {
    e.preventDefault();
    setError("");
    if (!identifier.trim() || !password) { setError("Preencha todos os campos"); return; }
    setLoading(true);
    const res = await login(identifier.trim(), password, remember);
    setLoading(false);
    if (res.ok) { toast.success("Bem-vindo de volta!"); navigate("/feed"); }
    else setError(res.error || "Não foi possível entrar");
  };

  return (
    <div className="mc-container py-16 flex justify-center" data-testid="page-entrar">
      <div className="mc-card w-full max-w-md p-8 mc-fade-up">
        <h1 className="text-3xl font-bold text-center text-[#1e1b2e]">Bem-vindo ao Mora Comigo</h1>
        <p className="text-center text-muted-foreground mt-2 text-sm">Acesse sua conta e continue de onde parou.</p>

        <div className="grid grid-cols-2 gap-2 bg-[#f4f2fb] p-1 rounded-full mt-6">
          <button className="rounded-full py-2 text-sm font-semibold text-white mc-grad" data-testid="tab-entrar">Entrar</button>
          <button className="rounded-full py-2 text-sm font-semibold text-muted-foreground" data-testid="tab-registrar" onClick={() => navigate("/cadastro")}>Registrar</button>
        </div>

        <form onSubmit={submit} className="mt-6 space-y-4" noValidate>
          <div>
            <label className="block text-sm font-semibold text-[#1e1b2e] mb-2">Nome ou E-mail</label>
            <input className="mc-input" data-testid="login-identifier" placeholder="Digite seu nome ou e-mail" value={identifier} onChange={(e) => setIdentifier(e.target.value)} />
          </div>
          <div>
            <label className="block text-sm font-semibold text-[#1e1b2e] mb-2">Senha</label>
            <div className="relative">
              <input className="mc-input pr-11" type={showPw ? "text" : "password"} data-testid="login-password" placeholder="Digite sua senha" value={password} onChange={(e) => setPassword(e.target.value)} />
              <button type="button" onClick={() => setShowPw((s) => !s)} className="absolute right-4 top-1/2 -translate-y-1/2 text-muted-foreground" data-testid="toggle-password" aria-label="Mostrar senha">
                {showPw ? <EyeOff size={18} /> : <Eye size={18} />}
              </button>
            </div>
          </div>
          <div className="flex items-center justify-between">
            <label className="flex items-center gap-2 text-sm text-[#1e1b2e] cursor-pointer">
              <input type="checkbox" data-testid="login-remember" checked={remember} onChange={(e) => setRemember(e.target.checked)} className="accent-violet-600 w-4 h-4" />
              Lembrar neste dispositivo
            </label>
            <Link to="/recuperar-senha" className="text-sm font-semibold text-violet-600 hover:underline" data-testid="forgot-link">Esqueceu a senha?</Link>
          </div>
          {error && <p className="text-destructive text-sm" data-testid="login-error">{error}</p>}
          <button className="btn-primary w-full" data-testid="login-submit" disabled={loading}>{loading ? "Entrando..." : "Acessar minha conta"}</button>
        </form>
      </div>
    </div>
  );
}
